export default {
    data: () => ({
        translations: {
            title: {
                el: "Ταμειακές Μηχανές",
                en: "Cash Registers",
                it: "Registri di Cassa"
            },
            formtitle: {
                el: "Ταμειακής Μηχανής",
                en: "Cash Register",
                it: "Registratore di Cassa"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            friendlyName: {
                el: "Φιλική ονομασία",
                en: "Friendly Name",
                it: "Nome Amico"
            },
            code: {
                el: "Κωδικός",
                en: "Code",
                it: "Codice"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            create: {
                el: "Δημιουργία",
                en: "Create",
                it: "Creare"
            },
            edit: {
                el: "Επεξεργασία",
                en: "Edit",
                it: "Modifica"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            addNew: {
                el: "Προσθήκη νέας",
                en: "Add new",
                it: "Aggiungi un nuovo"
            },
            deleteWarningPart1: {
                el: "Σίγουρα θέλετε να διαγράψετε την μηχανή με όνομα: ",
                en: "Are you sure you want to delete the cash register with name: ",
                it: "Siete sicuri di voler eliminare il registratore di cassa con il nome: "
            },
            deleteWarningPart2: {
                el: " και κωδικό: ",
                en: " and code: ",
                it: " e codice: "
            },
            questionmark: {
                el: ";",
                en: "?",
                it: "?"
            }
        }
    })
};
